<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card
          border-variant="info"
          header-bg-variant="primary"
          header-text-variant="white"
          class="card-wrap"
        >
          <div slot="header">
            <strong>View Coupon</strong>
            <eb-button
              style="color: white; font-weight: bold; float: right"
              text="Back"
              @click="(e) => $emit('view', e)"
            ></eb-button>
          </div>
          <b-row>
            <b-col md="4">
              <div class="form-group">
                <label for="promoCode">Coupon Code</label>
                <b-form-input
                  id="promoCode"
                  disabled
                  inputType="text"
                  v-model="details.promoCode"
                />
              </div>
            </b-col>
            <b-col md="4">
              <div class="form-group">
                <label for="categoryOptions">Applicable On</label>
                <b-form-input
                  id="categoryOptions"
                  type="text"
                  disabled
                  label="label"
                  v-model="details.promoRules.applicableOn"
                ></b-form-input>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <div class="form-group">
                <label for="title">Title</label><br />
                <b-form-input
                  id="title"
                  type="text"
                  disabled
                  label="label"
                  v-model="details.title"
                ></b-form-input>
              </div>
            </b-col>
            <b-col md="4">
              <div class="form-group">
                <label for="description">Description</label><br />
                <b-form-input
                  id="description"
                  type="text"
                  disabled
                  label="label"
                  v-model="details.description"
                ></b-form-input>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <div class="form-group">
                <label for="startdate">Start Date</label>
                <b-input
                  id="startdate"
                  disabled
                  type="text"
                  v-model="details.promoRules.startDate"
                ></b-input>
              </div>
            </b-col>
            <b-col md="4">
              <div class="form-group">
                <label for="enddate">End Date:</label>
                <b-input
                  id="enddate"
                  disabled
                  type="text"
                  v-model="details.promoRules.endDate"
                ></b-input>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <div class="form-group">
                <label for="maxRewardValue">Max Reward Value</label>
                <b-form-input
                  id="maxRewardValue"
                  inputType="text"
                  :disabled="true"
                  maxlength="100"
                  v-model="details.promoRules.maxRewardValue"
                />
              </div>
            </b-col>
            <b-col md="4">
              <div class="form-group">
                <label for="minimumAmountExcludingTax"
                  >MinimumAmount Excluding Tax</label
                >
                <b-form-input
                  id="minimumAmountExcludingTax"
                  inputType="text"
                  disabled
                  maxlength="100"
                  v-model="details.promoRules.minimumAmountExcludingTax"
                />
              </div>
            </b-col>
          </b-row>
          <div>
            <b-row>
              <b-col md="4">
                <div class="form-group">
                  <label for="discountType">Discount Type</label>
                  <b-form-input
                    id="discountType"
                    type="text"
                    disabled
                    label="label"
                    v-model="details.promoRules.discountType"
                  ></b-form-input>
                </div>
              </b-col>
              <b-col md="4">
                <div class="form-group">
                  <label for="rewardValue">Reward Value</label>

                  <b-input
                    id="rewardValue"
                    disabled
                    type="text"
                    v-model="details.promoRules.rewardValue"
                  ></b-input>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <div class="form-group">
                  <label for="rewardType">Reward Type</label>
                  <b-form-input
                    id="rewardType"
                    disabled
                    type="text"
                    label="label"
                    v-model="details.promoRules.rewardType"
                  ></b-form-input>
                </div>
              </b-col>
              <!-- <b-col md="5">
                  <label for="promotion-tag">tags</label>
                    <b-form-input
                    disabled
                      input-id="promotion-tag"
                      v-model="details.tags"
                    ></b-form-input>
                </b-col> -->
              <b-col md="4">
                <div class="form-group">
                  <label for="within">Frequency in minutes</label>
                  <b-form-input
                    id="within"
                    disabled
                    inputType="text"
                    v-model="details.timingRules.within"
                  />
                </div>
              </b-col>
            </b-row>
          </div>
          <b-row>
            <!-- <b-col md="5">
                  <label for="within">Frequency in minutes</label>
                    <b-form-input
                      id="within"
                      disabled
                      inputType="text"
                      v-model="details.timingRules.within"
                    />
                </b-col> -->

            <b-col md="4">
              <div class="form-group">
                <label for="totalLimit">Total allowed in day</label>
                <b-form-input
                  id="totalLimit"
                  disabled
                  inputType="text"
                  v-model="details.timingRules.totalLimit"
                />
              </div>
            </b-col>
            <b-col md="4" class="pr-0">
              <div class="form-group">
                <label for="tc">Terms And Conditions</label><br />
                <b-form-input
                  id="tc"
                  disabled
                  inputType="text"
                  v-model="details.tc"
                />
              </div>
            </b-col>
          </b-row>
          <b-row> </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import cInput from "@/components/Common/CustomInput";
import { shuffleArray } from "@/shared/utils";
import ebSelect from "@/components/FormElements/Select.vue";
import { Vue, Component, Prop } from "vue-property-decorator";
import axios from "axios";
import ebButton from "@/components/FormElements/Button";
import CouponDetails from "@/components/MasterSetup/Coupon/CouponDetails";
import moment from "moment";

export default {
  name: "ViewCoupon",
  components: {
    ebButton,
    cInput,
    ebSelect,
    CouponDetails,
  },

  data: () => {
    return {};
  },
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
  computed: {
    userRole() {
      if (this.$store.getters["auth/getUserRole"]) {
        return this.$store.getters["auth/getUserRole"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
      }
    },
  },
};
</script>
<style scoped>
.fa-plus {
  border-top-right-radius: 10px;
  border-top-left-radius: 17px;
  border-bottom-left-radius: 17px;
  background-color: #f0f3f5;
}
</style>
